import { AuthApi } from '../auth/authApi';
import { Singleton } from '@/decorators';
import type {
  GetClientRequestDTO,
  GetClientResponseDTO,
  GetClientsResponseDTO,
} from './DTOs';
import type { Result } from '@/types/result.interface';
import type { AppError } from '@/types/errors.interface';
import { wrapHttpCall } from '../utils/apiResultMapper';

/**
 * Client API (Framework Agnostic)
 * 
 * Handles client data retrieval.
 */
@Singleton
export class ClientApi extends AuthApi {
  constructor() {
    super();
  }

  async getClient(body: GetClientRequestDTO): Promise<Result<GetClientResponseDTO, AppError>> {
    return wrapHttpCall(() => this.api.get<GetClientResponseDTO>(
      `/Client/${body.pyxisClientId}`,
    ));
  }

  async getClients(): Promise<Result<GetClientsResponseDTO, AppError>> {
    return wrapHttpCall(() => this.api.get<GetClientsResponseDTO>('/Client'));
  }
}
